import { ReactElement, ReactNode } from 'react';
import {
  ScheduleBadgesContainer, ScheduleHoursContainer, ScheduleHoursTitle,
} from '../styles';
import { ScheduleBadge } from './ScheduleBadge';
import Skeleton from 'react-loading-skeleton';
import { useTranslation } from 'react-i18next';

interface ScheduleHoursContentProps {
  automationIntervals: {startTime: string, endTime: string}[];
  loading: boolean;
}

export function ScheduleHoursContent({
  automationIntervals,
  loading,
}: ScheduleHoursContentProps): ReactElement {
  const { t } = useTranslation();

  function renderIntervals(): ReactNode {
    if (automationIntervals.length === 0) {
      return (
        <ScheduleBadge />
      );
    }

    return (
      <>
        {automationIntervals.map((interval) => (
          <ScheduleBadge
            beginTime={interval.startTime}
            endTime={interval.endTime}
            key={`${interval.startTime}-${interval.endTime}`}
          />
        ))}
      </>
    );
  }

  if (loading) {
    return (
      <ScheduleHoursContainer>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Skeleton width="310px" height="20px" borderRadius={8} />
        </div>

        <ScheduleBadgesContainer>
          <Skeleton width="258px" height="30px" borderRadius={1000} />
        </ScheduleBadgesContainer>
      </ScheduleHoursContainer>
    );
  }

  return (
    <ScheduleHoursContainer>
      <ScheduleHoursTitle>
        {t('horarioDeFuncionamento')}
      </ScheduleHoursTitle>

      <ScheduleBadgesContainer>
        {renderIntervals()}
      </ScheduleBadgesContainer>

      <div style={{ height: '60px' }} />
    </ScheduleHoursContainer>
  );
}
